export default class MathService {
    public static lcmm(args: number[]): number {
        if (args.length === 0) { return 0; }
        if (args.length === 1) { return args[0]; }
        if (args.length === 2) {
            return this.lcm(args[0], args[1]);
        } else {
            let arg0 = args[0];
            args.shift();
            return this.lcm(arg0, this.lcmm(args));
        }
    }

    private static lcm(a: number, b: number): number {
        return (a * b / this.gcd(a, b));
    }

    private static gcd(a: number, b: number): number {
        let x: number;
        while (b !== 0) {
            x = b;
            b = a % b;
            a = x;
        }
        return a;
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/math-service.ts